export default "__VITE_ASSET__DYuj7zib__"